var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraggableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 3c0 .857-.695 1.552-1.552 1.552H1.552A1.552 1.552 0 010 3V1.552C0 .695.695 0 1.552 0h23.896C26.305 0 27 .695 27 1.552V3zm-9.31 7.992c0 .857-.695 1.551-1.552 1.551H1.552A1.552 1.552 0 010 10.992V9.543c0-.857.695-1.551 1.552-1.551h14.586a1.55 1.55 0 011.551 1.551v1.449zm-9.31 8.12c0 .857-.695 1.552-1.552 1.552H1.552A1.552 1.552 0 010 19.112v-1.448c0-.857.695-1.552 1.552-1.552h5.276c.857 0 1.551.695 1.551 1.552v1.448z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggableIcon);
export default __webpack_public_path__ + "static/media/draggable-icon.4d2ee5b99f96029573557e4e19690d6c.svg";
export { ForwardRef as ReactComponent };